export default class Version {
  label: string;
  parts: (string | number)[];

  constructor(value: string) {
    this.label = value;
    this.parts = value.split(/\b/).map(function (p) {
      const n = parseInt(p, 10);
      return isNaN(n) ? p : n;
    });
  }

  compare(other: Version) {
    for (let i = 0; i < Math.max(this.parts.length, other.parts.length); i++) {
      if (this.parts[i] === undefined) return -1;
      if (other.parts[i] === undefined) return 1;
      if (typeof this.parts[i] === 'string' && typeof other.parts[i] === 'number') return -1;
      if (typeof this.parts[i] === 'number' && typeof other.parts[i] === 'string') return 1;
      if (this.parts[i] < other.parts[i]) return -1;
      if (this.parts[i] > other.parts[i]) return 1;
    }
    return 0;
  }

  toString() {
    return this.label;
  }
}
